import {
	buildChartAxisTimestamps,
	buildPlaceholderAxis,
} from 'components/shared/processes/chartNoDataSeries'
import moment from 'moment'
import { useMemo } from 'react'
import ReactApexChart from 'react-apexcharts'
import { COLORS } from 'styles/colors'
import { localizationApexCharts } from 'utils'

const EmptyChartPlot = ({
	start,
	end,
	height = 250,
}: {
	start: number
	end: number
	height?: number
}) => {
	const axis = useMemo(() => {
		const days = buildChartAxisTimestamps(start, end, false)
		return buildPlaceholderAxis(days.length > 0 ? days : [start])
	}, [end, start])
	const options = useMemo(
		() => ({
			chart: {
				type: 'line' as const,
				toolbar: { show: false },
				zoom: { enabled: false },
				animations: { enabled: false },
				fontFamily: 'Montserrat',
				locales: localizationApexCharts(),
				defaultLocale: 'ru',
			},
			stroke: {
				width: 1.5,
				curve: 'straight' as const,
				lineCap: 'round' as const,
			},
			colors: [COLORS.inputBorder],
			markers: { size: 0, hover: { size: 0 } },
			dataLabels: { enabled: false },
			grid: { strokeDashArray: 6, borderColor: '#E6E6E8' },
			legend: { show: false },
			xaxis: {
				type: 'datetime' as const,
				tickAmount: Math.max(
					Math.min(buildChartAxisTimestamps(start, end, false).length - 1, 11),
					1,
				),
				crosshairs: {
					show: true,
					stroke: { width: 1, dashArray: 0, color: '#C4C4C8' },
				},
				labels: {
					formatter: (value: string) =>
						value ? moment(Number(value)).format('DD.MM') : '',
					style: {
						fontSize: '12px',
						fontFamily: 'Montserrat',
						colors: '#7F7F84',
					},
				},
				tooltip: { enabled: false },
			},
			yaxis: {
				min: 0,
				max: 1,
				tickAmount: 4,
				labels: {
					formatter: (value: number) => (value < 0.05 ? '0' : '-'),
					style: {
						fontSize: '12px',
						fontFamily: 'Montserrat',
						colors: '#7F7F84',
					},
				},
			},
			tooltip: {
				shared: true,
				intersect: false,
				custom: ({ dataPointIndex }: { dataPointIndex: number }) => {
					const date = moment(axis.timestamps[dataPointIndex]).format(
						'DD.MM.YY',
					)
					return `<div style="padding:12px;background:#fff;border-radius:12px;box-shadow:0 4px 16px rgba(0,0,0,.12)">
						<div style="font-size:12px;color:#7F7F84">Нет данных</div>
						<div style="margin-top:4px;font-size:12px;color:#7F7F84">${date}</div>
					</div>`
				},
			},
		}),
		[axis.timestamps, end, start],
	)

	return (
		<ReactApexChart
			type='line'
			height={height}
			options={options}
			series={[
				{
					name: 'Нет данных',
					data: axis.timestamps.map((date, index) => ({
						x: date,
						y: axis.values[index],
					})),
				},
			]}
		/>
	)
}

export default EmptyChartPlot
